import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@shared/state';
import { ProgressDashboard } from '../components/gamification/ProgressDashboard';

export function ProfileProgressPage() {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;

  return (
    <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <header className="mb-6">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-content">
          Your progress
        </h1>
        <p className="text-sm font-body text-content-secondary mt-1">
          Streak, level and achievements — adapted to your motivation profile.
        </p>
      </header>
      <ProgressDashboard userId={user.uid} />
    </main>
  );
}
